export default "__VITE_ASSET__hkfG5IzA__"